/// <reference path="Plugins/Bibliography/BibliographyModule.tsx"/>
/// <reference path="Plugins/DropdownSelect/itjakub.plugins.dropdownselect.ts"/>

//  XXX: we don’t get a clue about the default export’s name but we can hack it
// @ts-ignore
defaultImportState.moduleName = "Dropzone";
import Dropzone from "dropzone";

//  XXX: this does nothing now, we’re a module
var localization: Localization;

import { BookPage } from "./Plugins/Reader/itjakub.plugins.reader";

// NOPE: use the helper function (makeGlobal) – if necessary (it’s not)
// var Dropzone = self._workaround_umd_exports.Dropzone;

// Disable Dropzone auto-initializing
Dropzone.autoDiscover = false;

// https://stackoverflow.com/questions/2304941/what-is-the-non-jquery-equivalent-of-document-ready
function dom_ready(callback: () => void)
{
    // If we’re early to the party.
    document.addEventListener('DOMContentLoaded', callback);

    // If late; I mean on time.
    if (document.readyState === 'interactive' || document.readyState === 'complete')
        callback();
}

//sets state to main plugins menu
//  OLD: $(document as Node as Element).ready(() => {
function l10n_and_jQuery()
{
    localization = new Localization();
    localization.configureSiteUrl(getBaseUrl());

    //  XXX: this is a necessary manual “export” to the global scope – we’re
    //       switching to modules…
    // TODO: use the helper function (makeGlobal)
    window.localization = localization;

    var loader = new lv();
    loader.initLoaderAll();
    loader.startObserving();

    // Fix navigation menu behavior for touch devices
    var collapsibleMenu = $(".main-navbar-container .navbar-collapse.collapse");
    var navbarItems = $(".secondary-navbar-toggle");
    $("[data-toggle=\"tooltip\"]").tooltip();

    $('#main-plugins-menu').find('li').removeClass('active');
    var href = window.location.pathname;
    var liTargetingActualPage = $('#main-plugins-menu').find("a[href='" + href.toString() + "']").parent('li');
    $(liTargetingActualPage).addClass('active');
    $(liTargetingActualPage).parents('li').addClass('active');

    $(".navbar-toggle .glyphicon.glyphicon-menu-hamburger").on("touchstart",
        (event) => {
            $(event.currentTarget.parentElement).toggleClass("toggled");
        });

    $("#defaultUserMenuItemLink").on("touchstart touchend",
        (event) => {
            event.preventDefault();
        });

    $("#main-plugins-menu > ul > li > a").on("touchstart",
        (event) => {
            var $liElement = $(event.currentTarget as Node as Element).closest(".has-sub");
            if($liElement.length)
            {
                event.preventDefault();
                $liElement.siblings().removeClass("hover");
                navbarItems.removeClass("hover");
                $liElement.toggleClass("hover");
            }
        });
    navbarItems.on("touchstart",
        (event) => {
            var target = $(event.target as Node as Element);
            if (target.is("a") || target.parents(".navbar-login").length) {
                return;
            }
            event.preventDefault();
            collapsibleMenu.collapse("hide");
            var $buttonElement = $(event.currentTarget as Node as Element);
            $buttonElement.siblings(".secondary-navbar-toggle").removeClass("hover");
            $("#main-plugins-menu > ul > li").removeClass("hover");
            $buttonElement.toggleClass("hover");
        });

    collapsibleMenu.on("show.bs.collapse", () => {
        $(".secondary-navbar-toggle").removeClass("hover");
    });
}

dom_ready(l10n_and_jQuery);

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind
function getStringOrFallbackExtension(key: string): string {
    var stringId = key; // the keys also (currently) work as default string IDs

    if (this.stringIds !== undefined && key in this.stringIds)
        stringId = this.stringIds[key];

    return localization.translate(stringId, this.localizationScope).value;
}

function getTextLegacy(msgId: string, scope?: string, cultureName?: string)
{
    // tooltips may be undefined
    if (!msgId) {
        return null;
    }

    //  XXX: message IDs in PluginsJs contain full stops! (rename them before
    //       using them here – if ever; or use a different separator: "/"?)
    if (!scope && msgId.includes('.')) {
        [scope, msgId] = msgId.split('.');
    }

    // NOTE: localization is a global variable
    const ret = localization.translate(msgId, scope, cultureName);

    return ret ? ret.value : `[${msgId}]`;
}

function getStringIdOrFallbackExtension(key: string): string {
    var stringId = key; // the keys also (currently) work as default string IDs

    if (this.stringIds !== undefined && key in this.stringIds)
        stringId = this.stringIds[key];

    let fluentStringId = stringId.replace(/([A-Z])/g, "-$1").substring(1).toLowerCase();
    return fluentStringId;
}

function getQueryStringParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    if (results === null) return "";
    var decoded = decodeURIComponent(results[1].replace(/\+/g, " "));
    decoded = replaceSpecialChars(decoded);
    return decoded;
}

function replaceSpecialChars(text : string): string {
    var decoded = text.replace(/&amp;/g, '&');   //TODO make better replace
    decoded = decoded.replace(/&gt;/g, '>');
    decoded = decoded.replace(/&lt;/g, '<');
    decoded = decoded.replace(/&quot;/g, '"');
    decoded = decoded.replace(/&#39;/g, "'");
    return decoded;
}

function escapeHtmlChars(text: string): string {
    if (!text) return "";
    var map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
    };
    return text.replace(/[&<>"']/g, char => map[char]);
}

function updateQueryStringParameter(key, value) {
    var uri = window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        history.replaceState(null,null,uri.replace(re, '$1' + key + "=" + encodeURIComponent(value) + '$2'));
    }
    else {
        history.replaceState(null, null,uri + separator + key + "=" + encodeURIComponent(value));
    }
}

function getBaseUrl() {
    var baseUrl = $("#baseUrl").data("path") as string;
    if (typeof baseUrl === "undefined") {
        baseUrl = "/";
    }
    return baseUrl;
}

function getBaseUrlWrapper(): string
{
    // https://novy.vokabular.ujc.cas.cz
    let baseUrl = getBaseUrl();

    if (baseUrl == '/') {
        baseUrl = `${location.origin}/`;
    }

    return baseUrl;
}

function convertDate(date: string): Date {
    return new Date(parseInt(date.substr(6)));
}

enum RoleEnum {
    EditLemmatization = 0
}

function isUserLoggedIn() {
    return $("#permissions-div").data("is-authenticated") === "True";
}

function isUserInRole(role: RoleEnum) {
    var paramRoleString = RoleEnum[role].toString();
    var rolesString = $("#permissions-div").data("roles");
    return rolesString.indexOf(paramRoleString) >= 0;
}

function onClickHref(event:JQuery.Event, targetUrl) {
    if (event.ctrlKey || event.which === 2) {
        event.preventDefault();

        window.open(targetUrl, '_blank');

        return false;
    } else {
        window.location.href = targetUrl;
    }
}

// An implementation of a case-insensitive contains pseudo
// made for all versions of jQuery
($ => {//TODO requires testing

    function icontains(elem, text) {
        return (
            elem.textContent ||
                elem.innerText ||
                $(elem).text() ||
                ""
        ).toLowerCase().indexOf((text || "").toLowerCase()) > -1;
    }

    $.expr.pseudos.containsCI = $.expr.createPseudo ?
        $.expr.createPseudo(text => elem => icontains(elem, text)) :
        <any>((elem, i, match) => icontains(elem, match[3])); //ELSE branch for backward compatibility - probably not required

})(jQuery);

function getImageResourcePath(): string {
    return getBaseUrl() + "images/";
}

// Automatic popover close, fix 2 clicks for reopening problem
$(document as Node as Element).on("click", (e) => {
    $('[data-toggle="popover"],[data-original-title]').each(function () {
        //the 'is' for buttons that trigger popups
        //the 'has' for icons within a button that triggers a popup
        if (!$(this as Node as Element).is(e.target as Node as Element) && $(this as Node as Element).has(e.target as Node as Element).length === 0 && $('.popover').has(e.target as Node as Element).length === 0) {
            (($(this as Node as Element).popover("hide").data("bs.popover") || {}).inState || {}).click = false; // fix for BS 3.3.6
        }
    });
});

// NOTE: this becomes (a) part of the bundle shared by dictionaries and editions

// TODO: remove this once we (re)implement interactivity in editions and
//       dictionaries with React
function activateTooltips(_page: BookPage, container: HTMLElement)
{
    const tooltips: NodeListOf<Element> = container.querySelectorAll(
        '[data-toggle="tooltip"]');

    // https://stackoverflow.com/questions/51723962/typescript-nodelistofelement-is-not-an-array-type-or-a-string-type
    for (let tooltip of tooltips as any) {
        $(tooltip).tooltip({
            title: getTooltipText,
            // don’t show/hide the tooltip immediately
            delay: {
                show: 200,
                hide: 200, // 400? more?
            },
        });
    }
}

//  OLD: return $(this.parentNode.querySelector(
//    `template[id="note-tooltip-contents-${tooltip.id.substr(4)}]`)).html();
function getTooltipText(): string
{
    let item: Element = this;

    // NOTE: the expected source is a <template> tag placed right behind the item
    //       in XSLT; however, jQuery creates a <div> with the tooltip also right
    //       behind the item and so we were getting a sort of an “Inception” effect
    //       when quickly leaving the item and returning to it
    // return this.nextElementSibling.innerHTML;

    while (item) {
        item = item.nextElementSibling;

        if (item && item.tagName.toLowerCase() == 'template')
            return item.innerHTML;
    }

    return null;
}

const urlRegex = /^https?:/;

// TODO: perform this with html-react-parser
function markUrlLinks(container: HTMLElement): void
{
    // NodeListOf<HTMLAnchorElement> (TypeScript infers this)
    const links = container.querySelectorAll('a');

    for (let element of links as any) {
        const link = element as HTMLAnchorElement;
        const text = link.innerText ?? '';

        if (text.match(urlRegex)) {
            link.classList.add('url');
        }
    }
}

// Export global functions (and the enum) for module imports
// NOTE: and since `exports` is set to `window` they actually immediately become
//       global – no need for makeGlobal anymore
export {
    RoleEnum,

    activateTooltips,
    dom_ready,
    escapeHtmlChars,
    getBaseUrl,
    getBaseUrlWrapper,
    getImageResourcePath,
    getQueryStringParameterByName,
    getStringOrFallbackExtension,
    getStringIdOrFallbackExtension,
    getTextLegacy,
    isUserLoggedIn,
    isUserInRole,
    markUrlLinks,
    onClickHref,
    replaceSpecialChars,
    updateQueryStringParameter,

    // NOPE! localization (a global variable set after/on page load)
};
